module.exports = __webpack_public_path__ + "static/media/3DPPA36.6dd9d90a.jpg";